import { ApiHttpService } from '../ApiHttpService';
import { CartItemSerializer } from '../serializers/CartItemSerializer';
import { ProductSerializer } from '../serializers/ProductSerializer';
import { Product } from '../../models/Product';

const CART_PATH = '/Usuario/Carrito';
const FAVORITES_PATH = '/Usuario/Favoritos';

class CartController {
  static async getCart() {
    const authenticated = true;
    const response = await ApiHttpService.get(CART_PATH, {}, authenticated);
    const cartData = (response.data || {});
    return (cartData.CarritoLinea || [])
      .map(CartItemSerializer.deSerialize)
      .map(item => ({
        amount: item.amount,
        product: new Product(item.product),
        serviceAmount: item.serviceAmount,
        state: item.state,
      }));
  }

  static async getFavorites() {
    const authenticated = true;
    const response = await ApiHttpService.get(FAVORITES_PATH, {}, authenticated);
    const favoritesData = (response.data || {});
    return (favoritesData.FavoritosLinea || [])
      .map(item => ProductSerializer.deSerialize(item.Articulos || {}))
      .map(prod => new Product(prod));
  }

  static updateCart(newCart = []) {
    const authenticated = true;
    const cartParams = {
      CarritoLinea: newCart.map(cartItem => (
        {
          CLiCantidad: cartItem.amount,
          CLiArticulos: parseInt(cartItem.product.id, 10),
          CLiCantidadInstalaciones: cartItem.serviceAmount,
        }
      )),
    };
    return ApiHttpService.post(CART_PATH, cartParams, authenticated);
  }

  static updateFavorites(newFavorites = []) {
    const authenticated = true;
    const favoriteParams = {
      FavoritosLinea: newFavorites.map(favoriteItem => (
        {
          FLiArticulos: favoriteItem.id,
        }
      )),
    };
    return ApiHttpService.post(FAVORITES_PATH, favoriteParams, authenticated);
  }
}

export { CartController };



// WEBPACK FOOTER //
// ./src/networking/controllers/CartController.js